module.exports = __webpack_public_path__ + "static/media/img_internal_mobility_03.fc18e9c8.png";